import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        newChatNum: '0',
        newFriendship: '0'
    },
    mutations: {
        updateChatNum(state, newValue) {
            state.newChatNum = newValue;
        },
        updateFriendship(state, newValue) {
            state.newFriendship = newValue;
        }
    }
});
